import {
  CasRenderAsOfArrayAsRows,
  CasRenderBoolTrue,
  CasCRUDTable,
} from 'src/compass/shared/components';
import { 
  AdditCompensationSelect,
  EntityInfoLRPAccounts,
  useNewUnassignedOptions,
  SALES_DASHBOARD_UNASSIGNED
} from 'src/compass/application/commissions';
import { CasRiskWithSalesManagerSelect, CasSourceSelect, CasYesNoSelect } from 'src/compass/application';
import CasLoader from 'src/compass/shared/components/CasLoader/CasLoader';

interface IProps {
  isCommissionContext?: boolean;
}

export default function CasLrpAccountsTable({ isCommissionContext = true }: IProps) {
  const [ unassignedOptions, isLoadingUnassignedOptions ] = useNewUnassignedOptions();

  if (isLoadingUnassignedOptions) return <CasLoader />;  
  return (
    <CasCRUDTable
      {...EntityInfoLRPAccounts}
      columns={[
        {
          field: 'name',
          showEditOnclick: true,
        },
        {
          field: 'servicing',
          label: 'Relationship Owner',
        },
        {
          field: 'customer',
          label: 'Customer',
        },
        {
          field: 'schedule',
        },
        {
          field: 'source',
          sortable: false,
          render: CasRenderAsOfArrayAsRows,
        },
        {
          field: 'type',
          sortable: false,
          render: CasRenderAsOfArrayAsRows,
        },
        {
          field: 'additional',
          sortable: false,
          render: CasRenderAsOfArrayAsRows,
        },
        {
          field: 'suspended',
          render: CasRenderBoolTrue,
        },
        {
          field: 'notes',
        },
        {
          field: 'isClosed',
          label: 'Closed',
          render: CasRenderBoolTrue,
        },
      ]}
      filters={[
        {
          name: 'name',
          label: 'Name',
        },
        {
          type: 'component',
          name: 'agentId',
          label: 'Relationship Owner or Additional',
          includeAllOption: true,
          component: CasRiskWithSalesManagerSelect,
        },
        {
          type: 'autocomplete',
          name: 'entityId',
          label: 'Customer',
          url: 'Utilities/Entity/List',
        },
        {
          type: 'component',
          name: 'sourceEmployeeId',
          label: 'Source',
          includeAllOption: true,
          component: CasRiskWithSalesManagerSelect,
        },
        {
          type: 'component',
          name: 'sharedSvc',
          label: 'Shared Svc',
          includeAllOption: true,
          component: CasYesNoSelect,
        },
        {
          type: 'component',
          name: 'sourceId',
          label: 'Type',
          includeAllOption: true,
          component: CasSourceSelect,
        },
        {
          type: 'component',
          name: 'additionalId',
          label: 'Additional',
          includeAllOption: true,
          component: AdditCompensationSelect,
        },
        {
          type: 'select',
          name: 'newUnassigned',
          label: 'New/Unassigned',
          initialValue: isCommissionContext ? null : SALES_DASHBOARD_UNASSIGNED,
          options: unassignedOptions,
        },
      ]}
      showAddButton={false}
    />
  );
}
